import InputForm from './InputForm';
import SelectForm from './SelectForm';
import InputNumberForm from './InputNumberForm';
import CascaderForm from './Cascader';
import DateForm from './DateForm';
import TreeSelectForm from './TreeSelectForm';


export const getMessage = (type = 1) => {
    let message = {
        1: '请输入',
        2: '请选择',
        3: '请输入',
        4: '请选择',
        5: '请选择',
        6: '请选择'
    };
    return message[type];
};

//验证规则
export const getRules = (props) => {
    let { field_type = 1, setting = {} } = props,
     rules = [];
    if (props.required === 0) {
        rules.push({ required: true, message: getMessage(props.field_type) });
    }
    //文本类型 --当前仅有文本类型有其他的规则限制
    if (field_type === 1 && setting.type !== 'tag') {
        if (setting.maxLength) {
            rules.push({ max: setting.maxLength, message: `最多输入${setting.maxLength}字` });
        }
    }

    // 日期范围类型 --判断必填
    if(field_type === 5 && setting.type === 'range'){
        rules.push({
            validator: (_, value) => {
                // 时间范围选择一个开始或结束后，需要提示错误信息
                if (value && value.length === 1) {
                    return Promise.reject(`${props.name} 开始/结束时间不能为空`);
                }
                return Promise.resolve();
            }
        });
    }
    //数值类型
    // if (field_type === 3) {
    //     let [min = 0, max = 100] = setting.number_range;
    //     rules.push({
    //         validator: (_, value) => {
    //             if (min <= value && value <= max) {
    //                 return Promise.resolve();
    //             }
    //             return Promise.reject(`数值范围${min}-${max}`);
    //         }
    //     });
    // }
    return rules;
};
//根据类型 选择不同的表单  // 1-文本 2-下拉 3-数值 4-级联 5-日期 6 -上传
export const getForm = (props) => {
    let { field_type = 1 } = props;

    switch (field_type) {
        case 2:
            return SelectForm(props);
        case 3:
            return InputNumberForm(props);
        case 4:
            return CascaderForm(props);
        case 5:
            return DateForm(props);
        case 7: //不存在7，是拿到数据单独处理的
            return TreeSelectForm(props);
        default:
            return InputForm(props);
    }
};

